<template>
    <div class="fill-height">
        <template v-if="!docCheckLoginLoading && docCheckLogin">
            <v-snackbar :color="snackbarColor" v-model="snackbarValue" top>
                {{ snackbarText }}
                <template v-slot:action>
                    <v-icon @click="hideSnackbar">mdi-close</v-icon>
                </template>
            </v-snackbar>
            <v-container v-if="docCheckLogin.header_image" fluid :style="`background: #f2f4f5`"
                         :class="$vuetify.breakpoint.smAndDown ?'pa-0' : 'py-0'">
                <v-row justify="center" no-gutters>
                    <v-col cols="12" md="10" lg="8" xl="6" class="pa-0">
                        <v-img :src="docCheckLogin.header_image"/>
                    </v-col>
                </v-row>
            </v-container>
            <v-container fluid class="fill-height">
                <v-row justify="center" align="center" class="fill-height">
                    <v-col cols="auto">
                        <v-card elevation="12" height="231">
                            <v-card-text class="pa-0" v-html="docCheckLogin.embed_code">
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
    import snackbar from '@/mixins/snackbar';


    export default {
        name: 'DocCheck',
        props: {
            url: String,
        },
        mixins: [
            snackbar,
        ],
        data: () => ( {
            results: {},
            validationErrors: {},
            valid: true,
            password: null,
            generalError: false,
            sending: false,
        } ),
        mounted ()
        {
            let url = this.$route.params.url;
            this.setDocCheckLoginLoading(true)
            // if(localStorage.getItem(AUTH_TOKEN)) {
            //     this.$router.push( { name: 'Event', params: { url: router.history.current.params.url } } );
            //     return
            // }
            this.$apollo.query( {
                query: gql`
                    query eventsForm($url: String!){
                        eventsForm(url: $url) {
                            id
                            docCheckLogin {
                                embed_code
                            }
                            header_image
                        }
                }`,
                variables: {
                    url: url,
                },
              fetchPolicy: "network-only"
            } ).then( ( { data } ) =>
            {
                if ( data )
                {
                  this.setDocCheckLoginLoading(false)
                    if ( data.eventsForm.docCheckLogin )
                    {
                        this.updateDocCheckLogin( data.eventsForm.docCheckLogin );
                    }
                }
            } );
        },
        methods: {
            ...mapActions( ['updateDocCheckLogin'] ),
            ...mapMutations( ['setDocCheckLoginLoading'] ),
        },
        computed: {
            ...mapState( ['docCheckLogin', 'docCheckLoginLoading', 'frame'] ),
            ...mapGetters( ['dark'] ),
        },
    };
</script>

<style scoped>

    >>>.v-toolbar__content{
        height: auto !important;
        min-height: 64px !important;
    }

</style>